import DocumentCardLivePreview from '../shared/DocumentCardLivePreview';
import {
    NID_PREVIEW_PORTRAIT, NID_PREVIEW_LANDSCAPE, NID_CARD_MM, nidMaxCopies,
} from './nidCardConstants';
import { computeNidCopyPairRects } from './nidToPdfEngine';

/**
 * The shared live page preview, wired to CR80 card geometry.
 *
 * The component itself lives in `shared/` because passport-to-pdf uses the same
 * one at a different page size; this file is only the NID measurements.
 */
export default function NidLivePreview(props) {
    return (
        <DocumentCardLivePreview
            {...props}
            cardMm={NID_CARD_MM}
            previewPortrait={NID_PREVIEW_PORTRAIT}
            previewLandscape={NID_PREVIEW_LANDSCAPE}
            maxCopies={nidMaxCopies}
            computeCopyPairRects={computeNidCopyPairRects}
            i18nRoot="nidToPdf"
        />
    );
}
